import React from 'react';
import styled from 'styled-components';

import useUI from 'src/hooks/use-ui';
import { ProductRecommendationSource } from 'src/utils/analytics/trackers/internal-gtm-tracker/internal-gtm-tracker.types';
import { ProductCarousel as ProductCarouselV2 } from 'src/components/carousel-v2/types/product-carousel';
import { useSponsoredProductHandlers } from 'src/utils/ads/hooks/sponsored-products';
import { useGetOnlySponsoredProducts } from 'src/utils/ads/hooks/sponsored-products/use-get-only-sponsored-products';

const TRACKER_SOURCE = ProductRecommendationSource.moloco;
const TITLE = 'Before You Go';

type SponsoredOnlyCartRecommendationsCarouselProps = {
  mt?: string;
  alwaysUseSmallCards?: boolean;
};

export function SponsoredOnlyCartRecommendationsCarousel({
  mt,
  alwaysUseSmallCards = false,
}: SponsoredOnlyCartRecommendationsCarouselProps): JSX.Element {
  const { closeCartDrawer } = useUI();
  const { products, loading } = useGetOnlySponsoredProducts();

  const { handleSponsoredProductClick, handleSponsoredProductImpression } = useSponsoredProductHandlers({
    trackerSource: TRACKER_SOURCE,
    adPlacement: 'cart.carousel',
  });

  const handleProductClick = (product, index): void => {
    handleSponsoredProductClick(product, index);
    closeCartDrawer();
  };

  return (
    <Wrapper>
      <ProductCarouselV2
        title={TITLE}
        products={products}
        isLoading={loading}
        source={TRACKER_SOURCE}
        isSmallTitle
        mt={mt}
        onProductClick={handleProductClick}
        onProductView={handleSponsoredProductImpression}
        onQuickAddToCart={handleSponsoredProductClick}
        alwaysUseSmallCards={alwaysUseSmallCards}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 0 20px;
`;
